/* Sunnafrucht Kassen-Pop-up, Teil 2: Anzeige und Klick auf "Zur Kasse" (16.10.2026).
   Desktop: Vorschläge nebeneinander, waagrecht scrollbar (Pfeile, Trackpad, Mausrad).
   Handy: Liste scrollt senkrecht, Versandbalken, Summe und Kassen-Knopf bleiben unten fest. */
(function () {
  'use strict';
  var SFKP = window.SFKP;
  if (!SFKP || !SFKP.fn || SFKP.ui) return;
  SFKP.ui = true;
  var F = SFKP.fn;
  var R = SFKP.R;
  var HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var SEL = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  var WIDE = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true };
  function sv(p, w) { return '<svg width="' + (w || 20) + '" height="' + (w || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
  var ICON = {
    close: sv('<path d="M6 6l12 12M18 6L6 18"/>', 22),
    cart: '<svg class="sfkp-i-cart" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3.5h2.6l2.4 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.7-7.3H6.3"/></svg>',
    check: '<svg class="sfkp-i-check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    truck: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h3.8l3.2 3.4V16h-7"/><circle cx="7" cy="17.6" r="1.7"/><circle cx="17.2" cy="17.6" r="1.7"/></svg>',
    arrow: sv('<path d="M5 12h14M13 6l6 6-6 6"/>', 18),
    prev: sv('<path d="M15 6l-6 6 6 6"/>'),
    next: sv('<path d="M9 6l6 6-6 6"/>')
  };

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }
  function setText(node, t) { node.textContent = t || ''; node.hidden = !t; }
  function build() {
    if (SFKP.root && document.body.contains(SFKP.root)) return SFKP.root;
    var root = el('div', 'sfkp');
    root.hidden = true;
    root.innerHTML =
      '<div class="sfkp__scrim" data-sfkp-close></div>' +
      '<div class="sfkp__dialog" role="dialog" aria-modal="true" aria-labelledby="sfkp-title" tabindex="-1">' +
      '<span class="sfkp__handle" aria-hidden="true"></span>' +
      '<button type="button" class="sfkp__close" data-sfkp-close aria-label="Schließen">' + ICON.close + '</button>' +
      '<div class="sfkp__head"><p class="sfkp__eyebrow"></p><h2 class="sfkp__title" id="sfkp-title"></h2><p class="sfkp__text"></p></div>' +
      '<div class="sfkp__body">' +
      '<button type="button" class="sfkp__nav sfkp__nav--prev" data-sfkp-nav="-1" aria-label="Vorherige Vorschläge" hidden>' + ICON.prev + '</button>' +
      '<div class="sfkp__list"></div>' +
      '<button type="button" class="sfkp__nav sfkp__nav--next" data-sfkp-nav="1" aria-label="Weitere Vorschläge" hidden>' + ICON.next + '</button>' +
      '</div>' +
      '<div class="sfkp__bottom">' +
      '<div class="sfkp__ship" aria-live="polite"><p class="sfkp__ship-text"></p><div class="sfkp__ship-row"><div class="sfkp__bar"><div class="sfkp__bar-fill"></div></div>' + ICON.truck + '</div></div>' +
      '<p class="sfkp__error" role="alert" hidden></p>' +
      '<div class="sfkp__foot"><div class="sfkp__sum"><span class="sfkp__sum-label">Zwischensumme <small>inkl. MwSt.</small></span><strong class="sfkp__sum-value"></strong></div>' +
      '<button type="button" class="sfkp__cta"><span class="sfkp__cta-label"></span>' + ICON.arrow + '</button></div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-sfkp-close]')) { e.preventDefault(); close(false); return; }
      var nv = t.closest('[data-sfkp-nav]');
      if (nv) { e.preventDefault(); slide(Number(nv.getAttribute('data-sfkp-nav'))); return; }
      if (t.closest('.sfkp__cta')) { e.preventDefault(); proceed(); }
    });
    var list = root.querySelector('.sfkp__list');
    list.addEventListener('scroll', nav, { passive: true });
    list.addEventListener('wheel', function (e) {
      if (!WIDE.matches || !list.classList.contains('is-scroll')) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = list.scrollWidth - list.clientWidth;
      if ((e.deltaY > 0 && list.scrollLeft >= max - 1) || (e.deltaY < 0 && list.scrollLeft <= 0)) return;
      list.scrollLeft += e.deltaY;
      e.preventDefault();
    }, { passive: false });
    window.addEventListener('resize', nav);
    SFKP.root = root;
    return root;
  }
  function nav() {
    var root = SFKP.root;
    if (!root || root.hidden) return;
    var list = root.querySelector('.sfkp__list');
    var on = WIDE.matches && list.classList.contains('is-scroll');
    var end = list.scrollWidth - list.clientWidth - 4;
    root.querySelector('.sfkp__nav--prev').hidden = !on || list.scrollLeft <= 4;
    root.querySelector('.sfkp__nav--next').hidden = !on || list.scrollLeft >= end;
    var m = list.querySelector('.sfkp-item__media');
    if (m) root.querySelector('.sfkp__body').style.setProperty('--sfkp-navtop', Math.round(m.offsetHeight / 2 + 2) + 'px');
  }
  function slide(dir) {
    var list = SFKP.root.querySelector('.sfkp__list');
    var card = list.querySelector('.sfkp-item');
    var step = card ? Math.max(card.offsetWidth + 16, list.clientWidth - card.offsetWidth) : list.clientWidth;
    try { list.scrollBy({ left: dir * step, behavior: 'smooth' }); } catch (e) { list.scrollLeft += dir * step; }
  }
  function mark(item, btn, name, on) {
    item.classList.toggle('is-added', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? name + ' wieder aus dem Warenkorb nehmen' : name + ' in den Warenkorb legen');
  }
  function card(p) {
    var x = F.parts(p.t);
    var item = el('div', 'sfkp-item');
    var media = el('div', 'sfkp-item__media');
    if (p.img) {
      var img = document.createElement('img');
      img.src = p.img;
      img.alt = x.name;
      img.width = 400;
      img.height = 400;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    var btn = el('button', 'sfkp-item__add');
    btn.type = 'button';
    btn.innerHTML = ICON.cart + ICON.check;
    var body = el('div', 'sfkp-item__body');
    body.appendChild(el('p', 'sfkp-item__name', x.name));
    if (x.weight || x.desc) {
      var meta = el('div', 'sfkp-item__meta');
      if (x.weight) meta.appendChild(el('span', 'sfkp-item__pill', x.weight));
      if (x.desc) meta.appendChild(el('span', 'sfkp-item__desc', x.desc));
      body.appendChild(meta);
    }
    var price = el('div', 'sfkp-item__price');
    price.appendChild(el('span', '', p.pf));
    if (p.up) price.appendChild(el('small', '', p.up));
    body.appendChild(price);
    item.appendChild(media);
    item.appendChild(btn);
    item.appendChild(body);
    mark(item, btn, x.name, false);
    btn.addEventListener('click', function () { toggle(p, item, btn, x.name); });
    return item;
  }
  function err(msg) {
    var e = SFKP.root && SFKP.root.querySelector('.sfkp__error');
    if (!e) return;
    e.textContent = msg || '';
    e.hidden = !msg;
  }
  function totals(c, total) {
    var root = SFKP.root;
    root.querySelector('.sfkp__sum-value').textContent = F.fmt(total);
    var box = root.querySelector('.sfkp__ship');
    if (!c.ship) { box.hidden = true; return; }
    box.hidden = false;
    var thr = Math.round(c.ship * F.rate());
    var rest = thr - total;
    var L = (window.KROWN && window.KROWN.settings && window.KROWN.settings.locales) || {};
    var text = root.querySelector('.sfkp__ship-text');
    var bar = root.querySelector('.sfkp__bar-fill');
    if (rest > 0) {
      box.classList.remove('is-free');
      text.textContent = F.plain(L.shipping_notice_remaining_to_free || 'Noch {{ remaining_amount }} bis zum kostenlosen Versand').replace(/\{\{\s*remaining_amount\s*\}\}/, function () { return F.fmt(rest); });
      bar.style.width = Math.max(3, Math.min(100, total / thr * 100)) + '%';
    } else {
      box.classList.add('is-free');
      text.textContent = F.plain(L.shipping_notice_eligible_for_free || 'Geschafft: Dein Versand ist kostenlos');
      bar.style.width = '100%';
    }
  }
  function toggle(p, item, btn, name) {
    var st = SFKP.st;
    var c = F.cfg() || {};
    if (btn.disabled) return;
    var on = !!st.added[p.v];
    err('');
    if (st.preview) {
      st.total += on ? -p.p : p.p;
      if (on) delete st.added[p.v]; else st.added[p.v] = 'vorschau';
      mark(item, btn, name, !on);
      totals(c, st.total);
      return;
    }
    btn.disabled = true;
    item.classList.add('is-busy');
    var req = on
      ? { url: 'cart/change.js', data: { id: st.added[p.v], quantity: 0 } }
      : { url: 'cart/add.js', data: { items: [{ id: p.v, quantity: 1, properties: { _quelle: 'Kassen-Pop-up' } }] } };
    fetch(R + req.url, { method: 'POST', headers: HDR, credentials: 'same-origin', body: JSON.stringify(req.data) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || '');
          return j;
        });
      })
      .then(function (j) {
        if (on) { delete st.added[p.v]; }
        else { var line = j && j.items && j.items[0] ? j.items[0] : j; st.added[p.v] = line && line.key ? line.key : p.v; }
        st.changed = true;
        mark(item, btn, name, !on);
        return F.getCart().then(function (cart) { st.total = cart.total_price; totals(c, cart.total_price); });
      })
      .catch(function (e) { err((e && e.message) || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.'); })
      .then(function () { btn.disabled = false; item.classList.remove('is-busy'); });
  }
  function open(c, res, preview) {
    var root = build();
    clearTimeout(SFKP.hideTimer);
    SFKP.st = { changed: false, added: {}, preview: !!preview, total: res.cart.total_price, origin: preview ? null : SFKP.origin };
    var h = res.head || {};
    setText(root.querySelector('.sfkp__eyebrow'), h.eyebrow);
    setText(root.querySelector('.sfkp__title'), h.title || 'Passt dazu');
    setText(root.querySelector('.sfkp__text'), h.text);
    root.querySelector('.sfkp__cta-label').textContent = c.cta || 'Weiter zur Kasse';
    var list = root.querySelector('.sfkp__list');
    list.innerHTML = '';
    res.items.forEach(function (p) { list.appendChild(card(p)); });
    list.classList.toggle('is-scroll', res.items.length > 3);
    list.scrollLeft = 0;
    list.scrollTop = 0;
    err('');
    totals(c, res.cart.total_price);
    root.hidden = false;
    root.getBoundingClientRect();
    root.classList.add('is-open');
    document.documentElement.classList.add('sfkp-lock');
    nav();
    var dlg = root.querySelector('.sfkp__dialog');
    dlg.scrollTop = 0;
    try { dlg.focus({ preventScroll: true }); } catch (e) { dlg.focus(); }
    document.addEventListener('keydown', onKey, true);
  }
  function close(silent) {
    var root = SFKP.root;
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sfkp-lock');
    document.removeEventListener('keydown', onKey, true);
    clearTimeout(SFKP.hideTimer);
    SFKP.hideTimer = setTimeout(function () { root.hidden = true; }, 260);
    if (silent) return;
    var st = SFKP.st || {};
    if (st.changed && !st.preview) { window.location.reload(); return; }
    if (st.origin && st.origin.focus) { try { st.origin.focus({ preventScroll: true }); } catch (e) {} }
  }
  function pass(t) {
    SFKP.passing = true;
    try { t.click(); } finally { setTimeout(function () { SFKP.passing = false; }, 0); }
  }
  function proceed() {
    var st = SFKP.st || {};
    close(true);
    if (st.preview) return;
    if (st.changed || !st.origin || !document.body.contains(st.origin)) { window.location.href = R + 'checkout'; return; }
    pass(st.origin);
  }
  function onKey(e) {
    if (!SFKP.root || SFKP.root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(false); return; }
    if (e.key !== 'Tab') return;
    var f = SFKP.root.querySelectorAll('button:not([disabled]):not([hidden])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function (e) {
    if (SFKP.passing) return;
    var t = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!t || (SFKP.root && SFKP.root.contains(t))) return;
    var c = F.cfg();
    if (!c || !c.enabled) return;
    if (c.once && F.seen() && !F.design()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (SFKP.busy) return;
    SFKP.busy = true;
    SFKP.origin = t;
    t.setAttribute('aria-busy', 'true');
    var done = false;
    function finish() { done = true; SFKP.busy = false; t.removeAttribute('aria-busy'); }
    var timer = setTimeout(function () { if (!done) { finish(); pass(t); } }, 4000);
    F.resolve(c).then(function (res) {
      if (done) return;
      clearTimeout(timer);
      finish();
      if (!res) { pass(t); return; }
      if (!F.design()) F.markSeen();
      open(c, res, false);
    }).catch(function () {
      if (done) return;
      clearTimeout(timer);
      finish();
      pass(t);
    });
  }, true);

  function prefetch() {
    var c = F.cfg();
    if (!c || !c.enabled || c.template !== 'cart' || (c.once && F.seen())) return;
    F.getCart().then(function (cart) {
      if (!cart.item_count) return;
      F.plan(c, cart).chain.forEach(function (r) { (r.targets || []).forEach(function (t) { F.feed(t.h); }); });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefetch); else prefetch();

  document.addEventListener('shopify:block:select', function (e) {
    var c = F.cfg();
    var id = e.detail && e.detail.blockId;
    if (!c || !id || !(c.rules || []).some(function (r) { return r.id === id; })) return;
    F.resolve(c, id).then(function (res) { if (res) open(c, res, true); }).catch(function () {});
  });
  document.addEventListener('shopify:block:deselect', function () { close(true); });
  document.addEventListener('shopify:section:select', function (e) {
    var c = F.cfg();
    if (!c || !e.detail || e.detail.sectionId !== c.section) return;
    F.resolve(c).then(function (res) { if (res) open(c, res, true); }).catch(function () {});
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var c = F.cfg();
    if (c && e.detail && e.detail.sectionId === c.section) close(true);
  });
})();